import { createContext, useState, useEffect } from "react";
import i18n from "../../i18n/i18n.js";

export const DetailsToMenu = createContext();
const toBaseLng = (lng) => (lng ? String(lng).split("-")[0] : "en");
export const DetailsProvider = ({ children }) => {
  const [language, setSelectedLanguage] = useState(
    toBaseLng(i18n.resolvedLanguage || i18n.language || "en")
  );
  const [clinicianName, setClinicianName] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const handleLogout = () => {
    setIsAuthenticated(false);
    setClinicianName("");
  };

  const checkAuthentication = async () => {
    try {
      const token = localStorage.getItem("authToken");
      setIsAuthenticated(!!token);
    } catch {
      // console.log("Error checking authentication status");
    }
  };

  const fetchClinicianName = async () => {
    try {
      if (isAuthenticated) {
        const detailsOfClinician = localStorage.getItem("clinician_name");
        setClinicianName(detailsOfClinician);
      }
    } catch {
      // console.log("Error when getting clinician's details");
    }
  };

  useEffect(() => {
    checkAuthentication();
  }, []);

  useEffect(() => {
    fetchClinicianName();
  }, [isAuthenticated]);

  const handleSelectLanguage = (lng) => {
    const base = toBaseLng(lng)
    i18n.changeLanguage(base);
    setSelectedLanguage(base);
  };

  useEffect(() => {
    const onLangChanged = (lng) => setSelectedLanguage(toBaseLng(lng));
    i18n.on("languageChanged", onLangChanged);
    return () => i18n.off("languageChanged", onLangChanged);
  }, []);

  return (
    <DetailsToMenu.Provider
      value={{
        language, // "en" | "ro" | "lt"
        setSelectedLanguage,
        clinicianName,
        setClinicianName,
        handleSelectLanguage,
        handleLogout,
        checkAuthentication,
      }}
    >
      {children}
    </DetailsToMenu.Provider>
  );
};
